import { IMatrix4, CameraMode } from '../api.js';
export class OrthographicProjection {
    constructor(left, right, bottom, top, near_z, far_z) {
        // TODO check if there are left, right, bottom, top;
        // otherwise inputs should be -halfWidth, halfWidth, -halfHeight, halfHeight
        this._projection_matrix = this.calculate_orthographic(left, right, bottom, top, near_z, far_z);
        this._is_dirty = false;
        this._left = left;
        this._right = right;
        this._top = top;
        this._bottom = bottom;
        this._near = near_z;
        this._far = far_z;
    }
    get_camera_mode() {
        return CameraMode.ORTHOGRAPHIC;
    }
    get_aspect_ratio() {
        return Math.abs(this.left - this.right) / Math.abs(this.top - this.bottom);
    }
    get_projection_matrix() {
        if (this._is_dirty) {
            this._is_dirty = false;
            this._projection_matrix = this.calculate_orthographic(this.left, this.right, this.bottom, this.top, this.near, this.far);
        }
        return this._projection_matrix;
    }
    get left() {
        return this._left;
    }
    set left(val) {
        if (val === this._left)
            return;
        this._left = val;
        this._is_dirty = true;
    }
    get right() {
        return this._right;
    }
    set right(val) {
        if (val === this._right)
            return;
        this._right = val;
        this._is_dirty = true;
    }
    get top() {
        return this._top;
    }
    set top(val) {
        if (val === this._top)
            return;
        this._top = val;
        this._is_dirty = true;
    }
    get bottom() {
        return this._bottom;
    }
    set bottom(val) {
        if (val === this._bottom)
            return;
        this._bottom = val;
        this._is_dirty = true;
    }
    get near() {
        return this._near;
    }
    set near(val) {
        if (val === this._near)
            return;
        this._near = val;
        this._is_dirty = true;
    }
    get far() {
        return this._far;
    }
    set far(val) {
        if (val === this._far)
            return;
        this._far = val;
        this._is_dirty = true;
    }
    clone() {
        return new OrthographicProjection(this.left, this.right, this.bottom, this.top, this.near, this.far);
    }
    /**
     * Calculate a right-handed orthographic projection
     * @param left the viewport left coordinate
     * @param right the viewport right coordinate
     * @param bottom the viewport bottom coordinate
     * @param top the viewport top coordinate
     * @param near_z the near clip plane
     * @param far_z the far clip plane
     * @returns orthographic projection matrix
     */
    calculate_orthographic(left, right, bottom, top, near_z, far_z) {
        const n = near_z;
        const f = far_z;
        const a = 2.0 / (right - left);
        const b = 2.0 / (top - bottom);
        const c = 2.0 / (f - n);
        const d = (f + n) / (f - n);
        const i0 = (right + left) / (right - left);
        const i1 = (top + bottom) / (top - bottom);
        const projection_matrix = IMatrix4.from_values(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, -i0, -i1, -d, 1.0);
        return projection_matrix;
    }
}
//# sourceMappingURL=OrthographicProjection.js.map